export default function MarkIcon({ mark }) {
  if (!mark) return <div />;

  let colorStyle = 'default-bg';
  if (mark == '1') colorStyle = 'red-bg';
  else if (mark == '2') colorStyle = 'orange-bg';
  else if (mark == '5') colorStyle = 'green-bg';

  return (
    <div className={'mark-icon-container ' + colorStyle}>
      <div className="mark-icon-style">{mark}</div>
    </div>
  );
}
